import FieldValue from 'domain/entity/preset/field/fieldValue';

type SelectorProperties = {
    icon?: string;
    shortLabel?: string;
    isDisabled?: boolean;
    disabled?: boolean;
};
export default class SelectorValue extends FieldValue {
    constructor(
        readonly label: string,
        readonly id: string,
        readonly selected: boolean,
        readonly properties: SelectorProperties | Record<string, never> = {},
        readonly children?: SelectorValue[],
        readonly selectable?: boolean,
        readonly disabled?: boolean
    ) {
        super(label, id);
    }
}
